module.exports = new __parcel__URL__("team.aa9af04e.svg").toString();